<template>
  <CFlex inline v-tooltip="getPriceApprovalStatusLabel(job.priceApproval.status)">
    <CColor v-if="showPrice" :theme="getPriceApprovalIconTheme(job.priceApproval.status)" class="c-job-price-approval-status-price">
      {{ price }}
    </CColor>
  </CFlex>
</template>

<script setup lang="ts">
  import { computed } from 'vue';
  import { useI18n } from 'vue-i18n';
  import AuthService from '@/general/services/AuthService';
  import CColor from '@/shared/components/CColor.vue';
  import CFlex from '@/shared/components/CFlex.vue';
  import Permission from '@/shared/constants/Permission';
  import { formatAmount } from '@/shared/utils/format';
  import { isPresent } from '@/shared/utils/typescript';
  import PriceDisplayOption from '../../constants/PriceDisplayOption';
  import Job from '../../models/Job';
  import { getPriceApprovalStatusLabel } from '../../utils/labels';
  import { getPriceApprovalIconTheme } from '../../utils/themes';

  const props = withDefaults(defineProps<{
    job: Job;
    display?: PriceDisplayOption;
  }>(), {
    display: PriceDisplayOption.WITH_VAT,
  });

  const i18n = useI18n();

  const price = computed(() => {
    const job = props.job;
    return isPresent(job.price.getAs(props.display)) ? formatAmount(job.price.getAs(props.display), true)
      : i18n.t('approvalModal.emptyPriceNoCurrency');
  });

  const showPrice = computed(() => {
    return AuthService.getCurrentUser().hasPermission(Permission.FRONTDESK) && props.job.price;
  });
</script>

<style lang="scss">
  .c-job-price-approval-status {
    &-price {
      min-width: 8ch;
      text-align: right;
      font-weight: $font-weight-bold;
    }
  }
</style>